import { useMutation } from '@apollo/react-hooks';
import { Form, Formik, FormikHelpers } from 'formik';
import gql from 'graphql-tag';
import React, { useState } from 'react';
import { Form as BForm, Button, Modal } from 'react-bootstrap';
import * as Yup from 'yup';
import { TextInput } from './common';
import { normalizeText } from './common/helpers';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/modals.css';

const loginMut = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password)
  }
`;

interface Values {
  email: string;
  password: string;
}

interface props {
  showModal: boolean;
  closeModal: () => void;
  createAccount: () => void;
  resetPassword: () => void;
}

export default function Login({
  showModal = false,
  closeModal,
  createAccount,
  resetPassword,
}: props) {
  const [error, setError] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const [authenticate] = useMutation(loginMut);

  function handleCloseModal() {
    setError('');
    closeModal();
  }

  function handleShowPassword(evt: React.ChangeEvent<HTMLInputElement>) {
    setShowPassword(evt.target.checked);
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        contentClassName="ec-modal-content"
      >
        <Modal.Header className="ec-modal-header" closeButton>
          <Modal.Title className="ec-modal-title">Log In</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={{
            email: '',
            password: '',
          }}
          validationSchema={Yup.object({
            email: Yup.string()
              .trim()
              .email('Invalid email address')
              .max(254)
              .required('Required'),
            password: Yup.string().required('Required'),
          })}
          onSubmit={async (
            values: Values,
            { setSubmitting }: FormikHelpers<Values>
          ) => {
            setError('');
            authenticate({
              variables: {
                email: normalizeText(values.email) || '',
                password: values.password,
              },
            })
              .then((data: any) => {
                if (!data.data.login) {
                  setSubmitting(false);
                  setError(
                    'Sorry, your email or password do not match what we have on record.'
                  );
                } else {
                  localStorage.setItem('token', data.data.login);
                  setSubmitting(false);
                  handleCloseModal();
                  //history.push("/main");
                  // window.location.assign('/#/main');
                  window.location.assign('/main');
                }
              })
              .catch((err: any) => {
                setError(
                  'Sorry, please try again. Contact Evichat if the error persists.'
                );
                console.log(err);
              });
          }}
        >
          {({ errors, isSubmitting }) => (
            <Form>
              <Modal.Body>
                <BForm.Group controlId="formBasicEmail">
                  <TextInput
                    label="Email"
                    name="email"
                    type="text"
                    inputMode="email"
                    autoComplete="username"
                  />
                </BForm.Group>

                <BForm.Group controlId="formBasicPassword">
                  <TextInput
                    label="Password"
                    name="password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                  />
                </BForm.Group>

                <BForm.Text className="ec-modal-error-msg ec-modal-login-error-msg">
                  <p>{error}</p>
                </BForm.Text>
              </Modal.Body>
              <Modal.Footer className="ec-modal-footer ec-modal-login-footer">
                <BForm.Check
                  checked={showPassword}
                  className="ec-modal-show-password"
                  id="checkShowPassword"
                  label="Show password"
                  onChange={handleShowPassword}
                  type="checkbox"
                />
                <Button
                  className="ec-modal-forgot-password"
                  onClick={resetPassword}
                >
                  Forgot Password?
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                  className="ec-modal-login-submit"
                >
                  Log In
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
        <div className="ec-modal-new-to-evichat-container">
          <p className="ec-modal-new-to-evichat">New to Evichat?</p>
          <p className="ec-modal-create-account" onClick={createAccount}>
            Create a new account
          </p>
        </div>
      </Modal>
    </>
  );
}
